<div class="h-full bg-white flex flex-col">
  <!-- ==================== HEADER ==================== -->
  <div class="p-4 border-b border-gray-200">
    <div class="flex items-center justify-between mb-3">
      <h2 class="text-lg font-bold text-gray-900">Paraclínicos</h2>
      <!-- Botón Volver (igual que en última consulta) -->
      <button
        type="button"
        (click)="onVolver()"
        class="p-2 text-gray-500 hover:text-primary hover:bg-purple-50 rounded-lg transition"
        title="Volver al expediente"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
      </button>
    </div>

    <!-- Botón Nuevo -->
    <div class="mb-3">
      <button
        type="button"
        (click)="crearNuevo()"
        class="w-full inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-[#AE91E3] text-white text-sm font-medium hover:bg-[#9b7ad4] transition"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
        </svg>
        Nuevo
      </button>
    </div>

    <!-- Dropdown tipo de estudio -->
    <div class="relative">
      <select
        [(ngModel)]="tipoSeleccionado"
        (ngModelChange)="cambiarTipoFiltro($event)"
        class="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-500 focus:border-purple-500 bg-white appearance-none cursor-pointer"
      >
        <option value="todos">Todos los estudios ({{ getContadorPorTipo('todos') }})</option>
        <option value="interno">Estudio Interno ({{ getContadorPorTipo('interno') }})</option>
        <option value="laboratorio">Estudio de Laboratorio ({{ getContadorPorTipo('laboratorio') }})</option>
        <option value="gabinete">Estudio de Gabinete ({{ getContadorPorTipo('gabinete') }})</option>
      </select>
      <svg
        class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  </div>

  <!-- ==================== LISTA DE PARACLÍNICOS ==================== -->
  <div class="flex-1 overflow-y-auto scrollbar-thin">
    <!-- Loading -->
    <div *ngIf="cargando" class="p-4 text-center text-gray-500">
      <svg class="animate-spin h-8 w-8 mx-auto mb-2 text-purple-600" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      <p class="text-sm">Cargando paraclínicos...</p>
    </div>

    <!-- Lista vacía -->
    <div *ngIf="!cargando && paraclinicos.length === 0" class="p-8 text-center text-gray-400">
      <svg class="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
      <p class="text-sm font-medium mb-1">No hay paraclínicos</p>
      <p class="text-xs">Haz clic en "Nuevo" para agregar uno</p>
    </div>

    <!-- Items -->
    <div class="p-4 space-y-3">
      <div
        *ngFor="let paraclinico of paraclinicos; trackBy: trackByParaclinico"
        (click)="seleccionarParaclinico(paraclinico)"
        class="paraclinico-floating-card"
        [class.selected]="paraclinico === paraclinicoSeleccionado"
      >
        <!-- Icono a la izquierda -->
        <div class="paraclinico-icon" [class.selected]="paraclinico === paraclinicoSeleccionado">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>

        <!-- Contenido en filas verticales -->
        <div class="paraclinico-content">
          <!-- Fila 1: Fecha pequeña -->
          <div class="paraclinico-fecha">
            {{ paraclinico.fecha | date : 'dd/MM/yyyy' }}
          </div>

          <!-- Fila 2: Título/Nombre grande -->
          <div class="paraclinico-titulo">
            {{ paraclinico.nombre || 'Sin nombre' }}
          </div>

          <!-- Fila 3: Interpretación/descripción -->
          <div
            *ngIf="paraclinico.interpretacion"
            class="paraclinico-descripcion"
            [innerHTML]="paraclinico.interpretacionSafe"
          ></div>
          <div *ngIf="!paraclinico.interpretacion" class="paraclinico-descripcion empty">
            Sin interpretación
          </div>

          <!-- Fila 4: Badge con buen contraste -->
          <div class="paraclinico-badge-row">
            <span
              class="tipo-badge"
              [class.laboratorio]="paraclinico.tipo === 'laboratorio'"
              [class.gabinete]="paraclinico.tipo === 'gabinete'"
              [class.interno]="paraclinico.tipo === 'interno'"
            >
              {{ paraclinico.tipo === 'laboratorio' ? 'Laboratorio' : paraclinico.tipo === 'gabinete' ? 'Gabinete' : paraclinico.tipo === 'interno' ? 'Interno' : 'General' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
